import { render } from "./BookingRestaurantForm.vue?vue&type=template&id=46e904a8&scoped=true"
import script from "./BookingRestaurantForm.vue?vue&type=script&lang=js"
export * from "./BookingRestaurantForm.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-46e904a8"

export default script